/**
 * Whether an SSO sign-in failed because the email has no SSO setup it can use: none for the
 * domain (404), or one whose domain is not verified yet (401). Both show the same "no connected
 * organization" message instead of the plugin's technical text.
 */
export function isNoUsableSsoProvider(status: number | undefined): boolean {
  return status === 404 || status === 401;
}
